<template>
  <div>
    <div id="template-solicitacao" class="template-solicitacao">

      <funcionalidade-header :titulo="tituloNavegacao"/>

      <div class="main">
        <solicitacao-listagem
          :chave-externa="'extrato'"
          :funcionalidade="funcionalidade"
          :rota-novo="rotaNovo"
          :rota-historico="rotaHistorico"
          :rota-detalhe="rotaDetalhe"
        />
      </div>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoListagem from '@/components/TemplateSolicitacao/SolicitacaoListagem'
import { mapState } from 'vuex'

export default {
  name: 'FuncionalidadeCustomizadaSolicitacaoComponent',
  data () {
    return {
      loaded: false
    }
  },
  components: {
    FuncionalidadeHeader,
    SolicitacaoListagem
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.nome
    },
    rotaNovo () {
      return `/${this.funcionalidade.idFuncionalidade}/novo`
    },
    rotaHistorico () {
      return `/${this.funcionalidade.idFuncionalidade}/historico`
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    }
  }
}
</script>
<style scoped>
.main {
  padding: 20px;
}
</style>
